import React from 'react';
import Modal from 'react-bootstrap/Modal';

import AsyncSelect from "react-select/async";
import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";

import { MultiSelect } from 'primereact/multiselect';

import './Style.css';

class ModalDemerito extends React.Component {

    constructor(props) {
        super(props);
    }

    debounce = (key, callback, delay = 250) => {
        clearTimeout(this.searchTimeouts[key]);

        this.searchTimeouts[key] = setTimeout(() => {
            callback();
        }, delay);
    };

    searchUsers = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            console.log(inputValue);
            const response = await axios.get(
                '/autocomplete-users',
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar operadores:', error);
            return [];
        }
    };

    searchBuildings = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            console.log(inputValue);
            const response = await axios.get(
                `/autocomplete/${this.props.cityPeriod.city_id}`,
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar empreendimentos:', error);
            return [];
        }
    };

    render() {

        this.motivos = [
            {
                value: "Demérito 1",
                label: "Demérito 1",
            },
            {
                value: "Demérito teste",
                label: "Demérito teste",
            },
            {
                value: "Demérito",
                label: "Demérito",
            },
            {
                value: "Execução",
                label: "Execução",
            },
            {
                value: "Testando",
                label: "Testando",
            },
        ];

        const {
            open,
            onClose,
        } = this.props;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={open}
                    onHide={onClose}
                    dialogClassName="modal-demerito"
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Demérito
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <form className="form-modal">
                            <div className="formulario">
                                <div className="form-group">
                                    <label>Operador</label>
                                    <AsyncSelect
                                        isMulti
                                        closeMenuOnSelect={ false }
                                        loadOptions={ this.searchUsers }
                                        getOptionLabel={(option) => option.text}
                                        getOptionValue={(option) => String(option.id)}
                                        onChange={(value) =>
                                            onFilterChange('user', value)
                                        }
                                        className="autocomplete"
                                        styles={ asyncSelectCustomStyles }
                                        placeholder="Buscar"
                                        components={ reactSelectIcons }
                                        noOptionsMessage={() => "Digite para buscar..."}
                                        loadingMessage={() => 'Carregando...'}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Empreendimento</label>
                                    <AsyncSelect
                                        isMulti
                                        closeMenuOnSelect={ false }
                                        loadOptions={ this.searchBuildings }
                                        getOptionLabel={(option) => option.text}
                                        getOptionValue={(option) => String(option.id)}
                                        onChange={(value) =>
                                            onFilterChange('name', value)
                                        }
                                        styles={ asyncSelectCustomStyles }
                                        className="autocomplete"
                                        placeholder="Buscar"
                                        components={ reactSelectIcons }
                                        noOptionsMessage={() => "Digite para buscar..."}
                                        loadingMessage={() => 'Carregando...'}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Motivo</label>
                                    <MultiSelect
                                        value=""
                                        options={ this.motivos }
                                        placeholder="Selecione"
                                        display="chip"
                                        showClear
                                        selectedItemsLabel="{0} itens selecionados"
                                        emptyFilterMessage="Nenhum resultado encontrado"
                                        className="dropdown"
                                        optionLabel="label"
                                        optionValue="value"
                                        filter
                                        filterBy="label"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Comentario</label>
                                    <textarea className='' placeholder='Digite' rows="3" cols="3"></textarea>
                                </div>

                                <div className="form-buttons">
                                    <button type="submit" className="btn btn-success btn-round background-brain">Salvar</button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalDemerito;